import React from 'react';

// Error boundaries must be class components (React has no hook equivalent) — the
// one sanctioned exception to the function-component convention. Contains a render
// crash to its subtree instead of white-screening the whole app, and surfaces the
// message so failures are diagnosable in place.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const { label = 'this section' } = this.props;
    return (
      <div style={{
        margin: 16, padding: '16px 18px', borderRadius: 10,
        background: 'var(--wi-background-bad)', color: 'var(--wi-status-bad)',
        border: '1px solid var(--wi-status-bad)', fontFamily: 'var(--wi-font-family)',
      }}>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 6 }}>
          Couldn’t render {label}.
        </div>
        <pre style={{
          margin: '0 0 10px', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
          fontSize: 12, lineHeight: 1.5, color: 'var(--wi-text-primary-bad, var(--wi-status-bad))',
        }}>{String(error?.message || error)}</pre>
        <button
          type="button"
          className="btn-secondary"
          style={{ fontSize: 13, padding: '6px 14px' }}
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    );
  }
}
